<template>
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col navigation-bottom">
          <Widget position="footer_menu_1" />
        </div>
        <div class="col navigation-bottom">
          <Widget position="footer_menu_2" />
        </div>
        <div class="col navigation-bottom">
          <Widget position="footer_menu_3" />
        </div>
        <div class="col soc-media">
          <Widget position="footer_socnetwork" />
        </div>
      </div>
      <Widget position="footer_copyright" />
      <Widget position="footer_partners" />
      <div class="app-dev">
        <Widget position="app_developer" />
      </div>
      <div class="app-dev">
        <Widget position="app_counter" />
      </div>
    </div>
  </footer>
</template>

<script>
import Widget from '@/components/app/Widget'

export default {
  components: {
    Widget
  }
}
</script>
